var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"height":"3","indeterminate":"","color":"blue darken-4"}}),_c('div',{staticClass:"text-h5 text-center my-3"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }